import { FETCH_HERO_BANNER } from '../actions';


export default function(state = [], action) {
    switch (action.type) {
        case FETCH_HERO_BANNER:
            return action.payload.data;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/fetch_hero_banner_reducer.js